import { render, staticRenderFns } from "./PrivacyRule.vue?vue&type=template&id=a311bd18&scoped=true&"
var script = {}
import style0 from "./PrivacyRule.vue?vue&type=style&index=0&id=a311bd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a311bd18",
  null
  
)

export default component.exports